import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "line-chart" }

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, BarChart } from "echarts/charts";
import { GridComponent, LegendComponent } from "echarts/components";
import VChart from "vue-echarts";
import { ref, onBeforeMount, withDefaults } from "vue";
import { get } from "@vueuse/core";

type IDataChart = {
  number_of_bookings?: any;
  number_of_impression?: any;
  labels?: any;
  loadedDataChart?: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'LineChart',
  props: {
    number_of_bookings: null,
    number_of_impression: null,
    labels: null,
    loadedDataChart: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { number_of_bookings?: any, number_of_impression?: any, labels?: any, loadedDataChart?: boolean };

use([CanvasRenderer, LineChart, BarChart, GridComponent, LegendComponent]);

let dataLineChart = ["2023年08月10日", "", "", "", "2023年09月10日"];
const option = ref({
  grid: {
    left: 20,
    right: 20,
    bottom: 20,
    containLabel: true,
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: false,
      axisTick: {
        show: true,
        interval: 3,
      },
      data: ["2023年08月10日", "", "", "", "2023年09月10日"],
      axisLabel: {
        rich: {
          firstLabel: {
            fontSize: 12,
            padding: [0, 0, 0, 92],
          },
          lastLabel: {
            fontSize: 12,
            padding: [0, 92, 0, 0],
          },
        },
        formatter: (value: string, index: number) => {
          const lastIndex = dataLineChart.length - 1;
          if (index === 0) {
            return "{firstLabel|" + value + "}";
          }
          if (index === lastIndex) {
            return "{lastLabel|" + value + "}";
          }
        },
      },
    },
    {
      data: ["2023年09月10日", "", "", "", "2023年09月10日"],
      boundaryGap: true,
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },
    },
  ],
  yAxis: {
    type: "value",
    axisLabel: {
      formatter: "{value}.00",
    },
  },
  legend: {
    orient: "horizontal",
    left: "left",
    x: "right",
    padding: [20, 0, 0, 50],
    itemGap: 20,
    color: ["#3871E0", "#C74030"],
    itemWidth: 30,
    itemHeight: 5,
    icon: "rect",
    data: ["予約CV数", "開封数"],
  },
  series: [
    {
      name: "予約CV数",
      type: "line",
      symbol: "none",
      data: [2, 1, 1.4, 2.6, 1.7],
      xAxisIndex: 0,
      itemStyle: {
        color: "#004FE1",
      },
      lineStyle: {
        color: "#004FE1",
        width: 2,
      },
    },
    {
      name: "開封数",
      symbol: "none",
      type: "line",
      data: [1.2, 2.2, 2.6, 1.8, 3],
      xAxisIndex: 0,
      itemStyle: {
        color: "#DF1515",
      },
      lineStyle: {
        color: "#DF1515",
        width: 2,
      },
    },
  ],
});
const loadDataChart = async () => {
  if (get(props.loadedDataChart)) {
    option.value.series[0].data = get(props?.number_of_bookings);
    option.value.series[1].data = get(props?.number_of_impression);
    option.value.xAxis[0].data = get(props?.labels);
    option.value.xAxis[1].data = get(props?.labels);
    dataLineChart = get(props.labels);
  }
};
onBeforeMount(async () => {
  await loadDataChart();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VChart), {
      ref: "line",
      class: "chart",
      option: option.value,
      autoresize: "",
      style: {"height":"200px","width":"100%","min-width":"500px"}
    }, null, 8, ["option"])
  ]))
}
}

})